import $ from 'jquery';

import '@fancyapps/fancybox';

$(function() {
  $(".fancybox:not(.slick-cloned .fancybox)").fancybox();
});